import iconeReseau from "../../assets/icons/network-svgrepo-com.svg";
import { Network } from "../Icons/Network";

export const Pbo = ({ pbo, port }) => {
  return (
    <div className="flex flex-wrap gap-1">
      <div className="px-3 border flex-row items-center border-primary rounded-full py-1 text-xs flex gap-1">
        <Network />
        <span className="font-medium truncate">{pbo ?? "--"}</span>
      </div>

      <div className="px-3 border flex-row items-center border-primary rounded-full py-1 text-xs flex gap-1">
        <img src={iconeReseau} className="w-4" alt="" />
        <p className="font-medium truncate">{port?.designation ?? "--"}</p>
      </div>
    </div>
  );
};
